var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-navigation-drawer",
        {
          staticClass: "sidedrawer",
          attrs: {
            clipped: "",
            app: "",
            width: _vm.drawerWidth,
            "disable-resize-watcher": true,
            permanent: "",
            id: "filter-menu"
          },
          model: {
            value: _vm.drawerValue,
            callback: function($$v) {
              _vm.drawerValue = $$v
            },
            expression: "drawerValue"
          }
        },
        [
          _c(
            "v-container",
            { attrs: { "grid-list-xs": "", "text-xs-center": "", "pa-0": "" } },
            [
              _c(
                "v-layout",
                { staticClass: "flex", attrs: { column: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c(
                        "v-toolbar",
                        { staticClass: "white", attrs: { flat: "" } },
                        [
                          _c(
                            "v-list",
                            { attrs: { dense: "" } },
                            [
                              _c(
                                "v-list-tile",
                                [
                                  _c(
                                    "v-list-tile-content",
                                    { staticClass: "title" },
                                    [
                                      _c(
                                        "v-tooltip",
                                        { attrs: { bottom: "" } },
                                        [
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "activator" },
                                              slot: "activator"
                                            },
                                            [
                                              _c(
                                                "v-toolbar",
                                                {
                                                  attrs: {
                                                    app: "",
                                                    "clipped-left": "",
                                                    flat: "",
                                                    color: "white"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      Filter by\n                      "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.updateFilters != null
                                                  ? "Apply new filter settings..."
                                                  : "Data is up-to-date with filter settings."
                                              ) +
                                              "\n                  "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-divider")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "" } },
                        [
                          _c("v-flex", [
                            _c(
                              "div",
                              {
                                style:
                                  "width: " + _vm.firstFilterColWidth + "px;"
                              },
                              [
                                _c(
                                  "v-list",
                                  {
                                    staticClass: "py-3",
                                    attrs: { "three-line": "" }
                                  },
                                  [
                                    _c(
                                      "v-list-tile",
                                      {
                                        class: _vm.locationFilterClass,
                                        on: {
                                          click: function($event) {
                                            return _vm.openLocationFilter()
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "v-badge",
                                          { attrs: { color: "primary" } },
                                          [
                                            _c(
                                              "v-list-tile-content",
                                              [
                                                _c(
                                                  "v-container",
                                                  {
                                                    staticClass: "pa-1",
                                                    attrs: {
                                                      "text-xs-center": ""
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "v-layout",
                                                      { attrs: { column: "" } },
                                                      [
                                                        _c(
                                                          "v-flex",
                                                          [
                                                            _c("v-icon", [
                                                              _vm._v(
                                                                "\n                                explore\n                              "
                                                              )
                                                            ])
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c("v-flex", [
                                                          _vm._v(
                                                            "\n                              Countries and Regions\n                            "
                                                          )
                                                        ])
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _vm.isSelectedDimensionOrComplement(
                                              _vm.constants.REGION_DIMENSION
                                            )
                                              ? _c(
                                                  "span",
                                                  {
                                                    attrs: { slot: "badge" },
                                                    slot: "badge"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                     " +
                                                        _vm._s(
                                                          _vm.$store.getters.getDimensionItems(
                                                            _vm.constants
                                                              .REGION_DIMENSION,
                                                            true
                                                          ).length
                                                        ) +
                                                        "\n                     "
                                                    )
                                                  ]
                                                )
                                              : _c(
                                                  "span",
                                                  {
                                                    attrs: { slot: "badge" },
                                                    slot: "badge"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                     " +
                                                        _vm._s(
                                                          _vm.$store.getters.getDimensionItems(
                                                            _vm.constants
                                                              .COUNTRY_DIMENSION,
                                                            true
                                                          ).length
                                                        ) +
                                                        "\n                     "
                                                    )
                                                  ]
                                                )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-list-tile",
                                      {
                                        class: _vm.topicFilterClass,
                                        on: {
                                          click: function($event) {
                                            return _vm.openTopicFilter()
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "v-badge",
                                          { attrs: { color: "primary" } },
                                          [
                                            _c(
                                              "v-list-tile-content",
                                              [
                                                _c(
                                                  "v-container",
                                                  {
                                                    staticClass: "pa-1",
                                                    attrs: {
                                                      "text-xs-center": ""
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "v-layout",
                                                      { attrs: { column: "" } },
                                                      [
                                                        _c(
                                                          "v-flex",
                                                          [
                                                            _c("v-icon", [
                                                              _vm._v(
                                                                "\n                                class\n                              "
                                                              )
                                                            ])
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c("v-flex", [
                                                          _vm._v(
                                                            "\n                              Classes and Subclasses\n                            "
                                                          )
                                                        ])
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _vm.isSelectedDimensionOrComplement(
                                              _vm.constants.SUBCLASS_DIMENSION
                                            )
                                              ? _c(
                                                  "span",
                                                  {
                                                    attrs: { slot: "badge" },
                                                    slot: "badge"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                     " +
                                                        _vm._s(
                                                          _vm.$store.getters.getDimensionItems(
                                                            _vm.constants
                                                              .SUBCLASS_DIMENSION,
                                                            true
                                                          ).length
                                                        ) +
                                                        "\n                     "
                                                    )
                                                  ]
                                                )
                                              : _c(
                                                  "span",
                                                  {
                                                    attrs: { slot: "badge" },
                                                    slot: "badge"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                     " +
                                                        _vm._s(
                                                          _vm.$store.getters.getDimensionItems(
                                                            _vm.constants
                                                              .CLASS_DIMENSION,
                                                            true
                                                          ).length
                                                        ) +
                                                        "\n                     "
                                                    )
                                                  ]
                                                )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _vm.filterDimension === "topic"
                            ? _c(
                                "v-flex",
                                { class: _vm.flexClass },
                                [
                                  _c(
                                    "v-list",
                                    [
                                      _c(
                                        "v-list-tile",
                                        [
                                          _c("v-list-tile-title", [
                                            _vm._v(
                                              "\n                Classes\n              "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-tile-action",
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: { icon: "" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.closeTopicFilter()
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v(
                                                      "\n                    close\n                  "
                                                    )
                                                  ])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile",
                                        {
                                          class: _vm.selectedItemClass(null),
                                          on: {
                                            click: function($event) {
                                              return _vm.toggleAllTopics()
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "v-list-tile-action",
                                            [
                                              _c("v-checkbox", {
                                                attrs: {
                                                  "input-value":
                                                    _vm.someTopicsSelected,
                                                  indeterminate:
                                                    _vm.allTopicsIndeterminate
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.toggleAllTopics()
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("v-list-tile-content", [
                                            _vm._v(
                                              "\n                indicator totals\n              "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _vm.isSelectedDimensionOrComplement(
                                            _vm.constants.SUBCLASS_DIMENSION
                                          )
                                            ? _c(
                                                "v-list-tile-action",
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: { icon: "" },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.selectDetailTopic(
                                                            null
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: { small: "" }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "arrow_forward_ios"
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list",
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        "v-list-tile",
                                        { staticStyle: { height: "50px" } },
                                        [
                                          _c(
                                            "v-list-tile-content",
                                            { staticStyle: { height: "50px" } },
                                            [
                                              _c(
                                                "v-text-field",
                                                {
                                                  attrs: {
                                                    "append-icon": "search",
                                                    clearable: ""
                                                  },
                                                  model: {
                                                    value: _vm.topicFilter,
                                                    callback: function($$v) {
                                                      _vm.topicFilter = $$v
                                                    },
                                                    expression: "topicFilter"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                default slot\n                "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.topicFilter !== null &&
                                      _vm.topicFilter !== "" &&
                                      _vm.filteredTopics.length !== 0
                                        ? _c("v-subheader", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.filteredTopics.length
                                              ) + " matching classes found"
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.topicFilter !== null &&
                                      _vm.topicFilter !== "" &&
                                      _vm.filteredTopics.length === 0
                                        ? _c("v-subheader", [
                                            _vm._v("No matching classes found")
                                          ])
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm._l(_vm.constants.ROOT_TOPICS, function(
                                    rootTopic
                                  ) {
                                    return [
                                      _c(
                                        "v-list",
                                        { key: rootTopic.code + "_head" },
                                        [
                                          _c(
                                            "v-list-tile",
                                            {
                                              on: {
                                                click: function($event) {
                                                  return _vm.toggleRootTopic(
                                                    rootTopic
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "v-list-tile-action",
                                                [
                                                  _c("v-checkbox", {
                                                    attrs: {
                                                      "input-value": _vm.someTopicsOfRootTopicSelected(
                                                        rootTopic
                                                      ),
                                                      indeterminate: _vm.allTopicsOfRootTopicIndeterminate(
                                                        rootTopic
                                                      )
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        return _vm.toggleRootTopic(
                                                          rootTopic
                                                        )
                                                      }
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c("v-list-tile-title", [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      rootTopic.text
                                                        .charAt(0)
                                                        .toUpperCase() +
                                                        rootTopic.text.slice(1)
                                                    ) +
                                                    "\n                  "
                                                )
                                              ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list",
                                        {
                                          key: rootTopic.code + "_body",
                                          attrs: { dense: "" }
                                        },
                                        _vm._l(
                                          _vm.filteredTopics.filter(function(
                                            t
                                          ) {
                                            return t.parent === rootTopic.code
                                          }),
                                          function(topic) {
                                            return _c(
                                              "div",
                                              {
                                                key: topic.code + topic.parent
                                              },
                                              [
                                                _c(
                                                  "v-list-tile",
                                                  {
                                                    class: _vm.selectedItemClass(
                                                      topic
                                                    ),
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.toggleTopic(
                                                          topic,
                                                          !topic.selected,
                                                          true
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "v-list-tile-action",
                                                      [
                                                        _c("v-checkbox", {
                                                          attrs: {
                                                            indeterminate:
                                                              _vm.isSelectedDimensionOrComplement(
                                                                _vm.constants
                                                                  .SUBCLASS_DIMENSION
                                                              ) &&
                                                              _vm.subtopics.some(
                                                                function(t) {
                                                                  return (
                                                                    t.parent ===
                                                                      topic.code &&
                                                                    t.selected
                                                                  )
                                                                }
                                                              ) &&
                                                              _vm.subtopics.some(
                                                                function(t) {
                                                                  return (
                                                                    t.parent ===
                                                                      topic.code &&
                                                                    !t.selected
                                                                  )
                                                                }
                                                              )
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                              return _vm.toggleTopic(
                                                                topic,
                                                                !topic.selected,
                                                                true
                                                              )
                                                            }
                                                          },
                                                          model: {
                                                            value:
                                                              topic.selected,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                topic,
                                                                "selected",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "topic.selected"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c("v-list-tile-content", [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            topic.text
                                                              .charAt(0)
                                                              .toUpperCase() +
                                                              topic.text.slice(
                                                                1
                                                              )
                                                          ) +
                                                          "\n                  "
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _vm.isSelectedDimensionOrComplement(
                                                      _vm.constants
                                                        .SUBCLASS_DIMENSION
                                                    )
                                                      ? _c(
                                                          "v-list-tile-action",
                                                          {
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                return _vm.selectDetailTopic(
                                                                  topic
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "v-btn",
                                                              {
                                                                attrs: {
                                                                  icon: ""
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    attrs: {
                                                                      small: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "arrow_forward_ios"
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e()
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "v-tooltip",
                                                  {
                                                    attrs: {
                                                      right: "",
                                                      disabled: _vm.isSelectedDimensionOrComplement(
                                                        _vm.constants
                                                          .SUBCLASS_DIMENSION
                                                      )
                                                    },
                                                    model: {
                                                      value: topic.tooltip,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          topic,
                                                          "tooltip",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "topic.tooltip"
                                                    }
                                                  },
                                                  [
                                                    _c("span", {
                                                      attrs: {
                                                        slot: "activator"
                                                      },
                                                      slot: "activator"
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        'Switch to "Explore ... by '
                                                      ),
                                                      _c("strong", [
                                                        _vm._v("SUBCLASS")
                                                      ]),
                                                      _vm._v(
                                                        '", respectively '
                                                      ),
                                                      _c("br"),
                                                      _vm._v(' "Show '),
                                                      _c("strong", [
                                                        _vm._v("SUBCLASS")
                                                      ]),
                                                      _vm._v(
                                                        ' ..." to browse the subclasses.'
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                      _vm._v(" "),
                                      _c("v-divider", {
                                        key: rootTopic.code + "_foot"
                                      })
                                    ]
                                  })
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.filterDimension === "location"
                            ? _c(
                                "v-flex",
                                { class: _vm.flexClass },
                                [
                                  _c(
                                    "v-list",
                                    [
                                      _c(
                                        "v-list-tile",
                                        [
                                          _c("v-list-tile-title", [
                                            _vm._v(
                                              "\n                Countries\n              "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-tile-action",
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: { icon: "" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.closeLocationFilter()
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v(
                                                      "\n                    close\n                  "
                                                    )
                                                  ])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile",
                                        {
                                          class: _vm.selectedItemClass(null),
                                          on: {
                                            click: function($event) {
                                              return _vm.toggleAllCountries()
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "v-list-tile-action",
                                            [
                                              _c("v-checkbox", {
                                                attrs: {
                                                  "input-value":
                                                    _vm.someCountriesSelected,
                                                  indeterminate:
                                                    _vm.allCountriesIndeterminate
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.toggleAllCountries()
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("v-list-tile-content", [
                                            _vm._v(
                                              "\n                all countries\n              "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _vm.isSelectedDimensionOrComplement(
                                            _vm.constants.REGION_DIMENSION
                                          )
                                            ? _c(
                                                "v-list-tile-action",
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: { icon: "" },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.selectDetailCountry(
                                                            null
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: { small: "" }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "arrow_forward_ios"
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list",
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        "v-list-tile",
                                        { staticStyle: { height: "50px" } },
                                        [
                                          _c(
                                            "v-list-tile-content",
                                            { staticStyle: { height: "50px" } },
                                            [
                                              _c(
                                                "v-text-field",
                                                {
                                                  attrs: {
                                                    "append-icon": "search",
                                                    clearable: ""
                                                  },
                                                  model: {
                                                    value: _vm.countryFilter,
                                                    callback: function($$v) {
                                                      _vm.countryFilter = $$v
                                                    },
                                                    expression: "countryFilter"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                default slot\n                "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.countryFilter !== null &&
                                      _vm.countryFilter !== "" &&
                                      _vm.filteredCountries.length !== 0
                                        ? _c("v-subheader", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.filteredCountries.length
                                              ) + " matching countries found"
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.countryFilter !== null &&
                                      _vm.countryFilter !== "" &&
                                      _vm.filteredCountries.length === 0
                                        ? _c("v-subheader", [
                                            _vm._v(
                                              "No matching countries found"
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm._l(_vm.filteredCountries, function(
                                        country
                                      ) {
                                        return _c(
                                          "div",
                                          { key: country.code },
                                          [
                                            _c(
                                              "v-list-tile",
                                              {
                                                class: _vm.selectedItemClass(
                                                  country
                                                ),
                                                on: {
                                                  click: function($event) {
                                                    return _vm.toggleCountry(
                                                      country,
                                                      true
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-list-tile-action",
                                                  [
                                                    _c("v-checkbox", {
                                                      attrs: {
                                                        indeterminate:
                                                          _vm.isSelectedDimensionOrComplement(
                                                            _vm.constants
                                                              .REGION_DIMENSION
                                                          ) &&
                                                          _vm.allRegions.some(
                                                            function(r) {
                                                              return (
                                                                r.country ===
                                                                  country.code &&
                                                                r.selected
                                                              )
                                                            }
                                                          ) &&
                                                          _vm.allRegions.some(
                                                            function(r) {
                                                              return (
                                                                r.country ===
                                                                  country.code &&
                                                                !r.selected
                                                              )
                                                            }
                                                          )
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.toggleCountry(
                                                            country,
                                                            false
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value: country.selected,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            country,
                                                            "selected",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "country.selected"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c("v-list-tile-content", [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(country.text) +
                                                      "\n                "
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _vm.isSelectedDimensionOrComplement(
                                                  _vm.constants.REGION_DIMENSION
                                                )
                                                  ? _c(
                                                      "v-list-tile-action",
                                                      {
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.selectDetailCountry(
                                                              country
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "v-btn",
                                                          {
                                                            attrs: { icon: "" }
                                                          },
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                attrs: {
                                                                  small: ""
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                      arrow_forward_ios\n                    "
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-tooltip",
                                              {
                                                attrs: {
                                                  right: "",
                                                  disabled: _vm.isSelectedDimensionOrComplement(
                                                    _vm.constants
                                                      .REGION_DIMENSION
                                                  )
                                                },
                                                model: {
                                                  value: country.tooltip,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      country,
                                                      "tooltip",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "country.tooltip"
                                                }
                                              },
                                              [
                                                _c("span", {
                                                  attrs: { slot: "activator" },
                                                  slot: "activator"
                                                }),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(
                                                    'Switch to "Explore ... by '
                                                  ),
                                                  _c("strong", [
                                                    _vm._v("REGION")
                                                  ]),
                                                  _vm._v('", respectively '),
                                                  _c("br"),
                                                  _vm._v(' "Show '),
                                                  _c("strong", [
                                                    _vm._v("REGION")
                                                  ]),
                                                  _vm._v(
                                                    ' ..." to browse the regions.'
                                                  )
                                                ])
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      })
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.filterDimension === "topic" &&
                          _vm.isSelectedDimensionOrComplement(
                            _vm.constants.SUBCLASS_DIMENSION
                          )
                            ? _c(
                                "v-flex",
                                { class: _vm.flexClass },
                                [
                                  _c(
                                    "v-list",
                                    [
                                      _c(
                                        "v-list-tile",
                                        [
                                          _vm.detailTopic !== null
                                            ? _c("v-list-tile-title", [
                                                _vm._v(
                                                  "\n                Subclasses of " +
                                                    _vm._s(
                                                      _vm.detailTopic.text
                                                    ) +
                                                    "\n              "
                                                )
                                              ])
                                            : _c("v-list-tile-title", [
                                                _vm._v(
                                                  "\n                Subclasses of all classes\n              "
                                                )
                                              ])
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile",
                                        {
                                          on: {
                                            click: function($event) {
                                              return _vm.toggleAllSubtopics()
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "v-list-tile-action",
                                            [
                                              _c("v-checkbox", {
                                                attrs: {
                                                  "input-value":
                                                    _vm.someSubtopicsSelected,
                                                  indeterminate:
                                                    _vm.allSubtopicsIndeterminate
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.toggleAllSubtopics()
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("v-list-tile-content", [
                                            _vm._v(
                                              "\n                all subclasses\n              "
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list",
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        "v-list-tile",
                                        { staticStyle: { height: "50px" } },
                                        [
                                          _c(
                                            "v-list-tile-content",
                                            { staticStyle: { height: "50px" } },
                                            [
                                              _c(
                                                "v-text-field",
                                                {
                                                  attrs: {
                                                    "append-icon": "search",
                                                    clearable: ""
                                                  },
                                                  model: {
                                                    value: _vm.subtopicFilter,
                                                    callback: function($$v) {
                                                      _vm.subtopicFilter = $$v
                                                    },
                                                    expression: "subtopicFilter"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                default slot\n                "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.subtopicFilter !== null &&
                                      _vm.subtopicFilter !== "" &&
                                      _vm.filteredSubtopics.length !== 0
                                        ? _c("v-subheader", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.filteredSubtopics.length
                                              ) + " matching subclasses found"
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.subtopicFilter !== null &&
                                      _vm.subtopicFilter !== "" &&
                                      _vm.filteredSubtopics.length === 0
                                        ? _c("v-subheader", [
                                            _vm._v(
                                              "No matching subclasses found"
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm._l(_vm.filteredSubtopics, function(
                                        subtopic
                                      ) {
                                        return _c(
                                          "v-list-tile",
                                          {
                                            key:
                                              subtopic.code +
                                              "_" +
                                              subtopic.parent,
                                            on: {
                                              click: function($event) {
                                                return _vm.toggleSubtopic(
                                                  subtopic,
                                                  !subtopic.selected,
                                                  true
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "v-list-tile-action",
                                              [
                                                _c("v-checkbox", {
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      return _vm.toggleSubtopic(
                                                        subtopic,
                                                        !subtopic.selected,
                                                        false
                                                      )
                                                    }
                                                  },
                                                  model: {
                                                    value: subtopic.selected,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        subtopic,
                                                        "selected",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "subtopic.selected"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("v-list-tile-content", [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(subtopic.text) +
                                                  "\n              "
                                              )
                                            ])
                                          ],
                                          1
                                        )
                                      })
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.filterDimension === "location" &&
                          _vm.isSelectedDimensionOrComplement(
                            _vm.constants.REGION_DIMENSION
                          )
                            ? _c(
                                "v-flex",
                                { class: _vm.flexClass },
                                [
                                  _c(
                                    "v-list",
                                    [
                                      _c(
                                        "v-list-tile",
                                        [
                                          _vm.detailCountry !== null
                                            ? _c("v-list-tile-title", [
                                                _vm._v(
                                                  "\n                Regions of " +
                                                    _vm._s(
                                                      _vm.detailCountry.text
                                                    ) +
                                                    "\n              "
                                                )
                                              ])
                                            : _c("v-list-tile-title", [
                                                _vm._v(
                                                  "\n                Regions of all countries\n              "
                                                )
                                              ])
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile",
                                        {
                                          on: {
                                            click: function($event) {
                                              return _vm.toggleAllRegions()
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "v-list-tile-action",
                                            [
                                              _c("v-checkbox", {
                                                attrs: {
                                                  "input-value":
                                                    _vm.someRegionsSelected,
                                                  indeterminate:
                                                    _vm.allRegionsIndeterminate
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.toggleAllRegions()
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("v-list-tile-content", [
                                            _vm._v(
                                              "\n                all regions\n              "
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list",
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        "v-list-tile",
                                        { staticStyle: { height: "50px" } },
                                        [
                                          _c(
                                            "v-list-tile-content",
                                            { staticStyle: { height: "50px" } },
                                            [
                                              _c(
                                                "v-text-field",
                                                {
                                                  attrs: {
                                                    "append-icon": "search",
                                                    clearable: ""
                                                  },
                                                  model: {
                                                    value: _vm.regionFilter,
                                                    callback: function($$v) {
                                                      _vm.regionFilter = $$v
                                                    },
                                                    expression: "regionFilter"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                default slot\n                "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.regionFilter !== null &&
                                      _vm.regionFilter !== "" &&
                                      _vm.filteredRegions.length !== 0
                                        ? _c("v-subheader", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.filteredRegions.length
                                              ) + " matching regions found"
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.regionFilter !== null &&
                                      _vm.regionFilter !== "" &&
                                      _vm.filteredRegions.length === 0
                                        ? _c("v-subheader", [
                                            _vm._v("No matching regions found")
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm._l(_vm.filteredRegions, function(
                                        region
                                      ) {
                                        return _c(
                                          "v-list-tile",
                                          {
                                            key: region.code,
                                            on: {
                                              click: function($event) {
                                                return _vm.toggleRegion(region)
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "v-list-tile-action",
                                              [
                                                _c("v-checkbox", {
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      return _vm.toggleRegion(
                                                        region
                                                      )
                                                    }
                                                  },
                                                  model: {
                                                    value: region.selected,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        region,
                                                        "selected",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "region.selected"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("v-list-tile-content", [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(region.text) +
                                                  "\n              "
                                              )
                                            ])
                                          ],
                                          1
                                        )
                                      })
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-divider")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("v-spacer")
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f1ae190", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f1ae190","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidedrawer.vue
// module id = null
// module chunks = 